// ---  external
import { cva } from "class-variance-authority";
// -----------------------------------------------------------------------------

export const labelVariants = cva("text-base text-sm font-medium");
// -----------------------------------------------------------------------------
export default {
  label: labelVariants
};
